import React, { Component } from 'react';
// import { VideoPlayer } from "../../n_components"

class TestPageNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boundingBoxes: {}
        };
        this.currentVideo = 'https://wearetravelers-locationimages.s3.eu-central-1.amazonaws.com/assets/files/demo-vid.mp4';
    }

    componentDidMount() {
        this.loadBoundingBoxData('demo-bounding.json');
    }
    loadBoundingBoxData = (fileName) => {
        fetch(fileName)
            .then(response => response.json())
            .then(data => this.setState({ boundingBoxes: data.boundingBoxes }))
            .catch(error => console.error('Error loading bounding box data:', error));
    };

    render() {
        return (
            <div>
                {/* <VideoPlayer url={this.currentVideo} boundingBoxes={this.state.boundingBoxes}></VideoPlayer> */}
            </div>

        );
    }
}

export default TestPageNew;
